import React from 'react';
import * as FaIcons from 'react-icons/fa';
import * as AiIcons from 'react-icons/ai';

export const SidebarData = [
  {
    title: 'Inicio',
    path: '/',
    icon: <AiIcons.AiFillHome />,
    cName: 'nav-text',
  },
  {
    title: 'Roadmap',
    path: '/roadmap',
    icon: <FaIcons.FaRoad />,
    cName: 'nav-text',
  },
  {
    title: 'Material',
    path: '/material/material',
    icon: <FaIcons.FaFileAlt />,
    cName: 'nav-text',
  },
];
